import '../LandingPage/LandingPage.scss';
import { Grid } from '@mui/material';

import CustomDashboardIcon from '../../assets/Custom Dashboard_Small.svg';
import { useEffect, useState, lazy } from 'react';
import KPILogo from '../../assets/kpistore.svg';
import landingBackArrow from '../../assets/landingBackArrow.svg';
import { usePepwiseAuthController } from 'Context/contexts/AuthContext';
import { useTheme } from '@mui/material/styles';

// Lazy load components
const Header = lazy(() => import('./Header'));
const Footer = lazy(() => import('../LandingPage/ModuleLandingFooter'));
const capabilitiesNew: any = localStorage.getItem('capabilities');

export default function AlertKpiLanding() {
  const theme = useTheme();
  const colors = theme.palette;
  const [, setMemberData] = useState<any>(null);
  const [controller, _] = usePepwiseAuthController();
  const { accessToken } = controller;

  // to display data
  useEffect(() => {
    setMemberData(accessToken);
  }, []);

  //navigate to data-pipeline observability
  const handleDataPipelineClick = (event: any, type: string, url: string) => {
    event.preventDefault(); // Prevent the default context menu from showing up
    if (type === 'blank') {
      // Open the URL in a new tab if type is 'blank'
      window.open(url, '_blank');
    } else {
      // Navigate to the provided URL in the current tab
      window.location.href = url;
    }
  };

  const handleBackClick = () => {
    window.location.href = '/LandingPage';
  };

  return (
    <div
      className="outerLandingPageContainer"
      style={{ backgroundColor: `${colors.backgroundLight.primary}` }}
    >
      {/* <Header memberData={memberData} /> */}
      <div style={{ maxWidth: '86%', margin: '0 auto' }}>
        <div className="landingMessage-container">
          <img
            src={landingBackArrow}
            alt="CCLogo"
            className="landingMessageImage"
            onClick={handleBackClick}
          />
          <p
            className="landingMessage"
            style={{ color: `${colors.textLight.secondary}` }}
          >{`Data KPI and Alerts`}</p>
        </div>

        <div className="welcome_text">
          <p style={{ color: `${colors.textLight.secondary}` }}>
            Click on the module below to monitor!
          </p>
        </div>
        <Grid container spacing={1} style={{ marginTop: '0px' }}>
          <Grid
            item
            xs={4}
            onClick={(e) => handleDataPipelineClick(e, 'no-blank', '/kpiFramework/configs')}
            onContextMenu={(e) => {
              e.preventDefault();
              handleDataPipelineClick(e, 'blank', '/kpiFramework/configs');
            }}
          >
            <div className="observalbility_screens" style={{ textAlign: 'center' }}>
              <div className="title">
                <img
                  src={KPILogo}
                  alt="CCLogo"
                  className="obs_logo"
                  style={{ display: 'block', margin: '0 auto' }}
                />
              </div>
              <div>
                <h3 className="obsTitle" style={{ margin: '10px 0' }}>
                  KPI Store
                </h3>
              </div>
              <p
                className="message1"
                title="Stay ahead with live monitoring of critical data KPIs."
                style={{ margin: '0', textAlign: 'center' }}
              >
                Stay ahead with live monitoring of critical data KPIs.
              </p>
            </div>
          </Grid>
          <Grid
            item
            xs={4}
            onClick={(e) => handleDataPipelineClick(e, 'no-blank', '/alertFramework/alert')}
            onContextMenu={(e) => {
              e.preventDefault();
              handleDataPipelineClick(e, 'blank', '/alertFramework/alert');
            }}
          >
            <div className="observalbility_screens" style={{ textAlign: 'center' }}>
              <div className="title">
                <img
                  src={CustomDashboardIcon}
                  alt="tableauLogo"
                  className="obs_logo"
                  style={{ display: 'block', margin: '0 auto' }}
                />
              </div>
              <div>
                <h3 className="obsTitle" style={{ margin: '10px 0' }}>
                  Alert Framework
                </h3>
              </div>
              <p
                className="message1"
                title="Detect issues before they impact business with near real-time notifications."
                style={{ margin: '0', textAlign: 'center' }}
              >
                Detect issues before they impact business with near real-time notifications.
              </p>
            </div>
          </Grid>
        </Grid>
      </div>
      <Footer />
    </div>
  );
}
